import React, { useRef } from 'react';

import ModalAiArtist from './ModalAiArtist';

import DavidNImg from '../../../../../Images/gallery/ai-services/david-n.png';
import Video1 from '../../../../../Images/gallery/ai-services/david-n/video-1.png';
import Video2 from '../../../../../Images/gallery/ai-services/david-n/video-2.png';
import Video3 from '../../../../../Images/gallery/ai-services/david-n/video-3.png';

import {
  DavidN_Title,
  DavidN_Text,
  DavidN_Video1,
  DavidN_Video2,
  DavidN_Video3,
} from '../../../../../utils/ES/Modals/aiArtists';

const ModalDavidN = () => {
  return (
    <>
      <ModalAiArtist
        id="artist-david-n"
        artistImage={DavidNImg}
        artistName="David N"
        artistTitle={DavidN_Title}
        artisText={DavidN_Text}
        videoRef1={'david-n-video-1'}
        videoBg1={Video1}
        videoText1={DavidN_Video1}
        videoRef2={'david-n-video-2'}
        videoBg2={Video2}
        videoText2={DavidN_Video2}
        videoRef3={'david-n-video-3'}
        videoBg3={Video3}
        videoText3={DavidN_Video3}
      />
    </>
  );
};

export default ModalDavidN;
